module.exports = __webpack_public_path__ + "static/media/img_7.1526cfe0.png";